export class DebouncedText{
  text: string = '';
  timeout: any = null;
  hasBeenSetRecently: boolean = false;

  get val(){
    return this.text;
  }

  set val(val: string){
    if(this.timeout){
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(()=>{
      this.hasBeenSetRecently = true;

      setTimeout(() => {
        this.hasBeenSetRecently = false;
      }, 1000)

      this.text = val;
    },500);
  }
}
